import { render, staticRenderFns } from "./OrdersellAnalysis.vue?vue&type=template&id=2c79d01d&scoped=true"
import script from "./OrdersellAnalysis.vue?vue&type=script&lang=js"
export * from "./OrdersellAnalysis.vue?vue&type=script&lang=js"
import style0 from "./OrdersellAnalysis.vue?vue&type=style&index=0&id=2c79d01d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79d01d",
  null
  
)

export default component.exports